<template>
  <div
    :class="[
      bem.b(),
      bem.is('active', isActive),
      bem.is('disabled', isDisabled)
    ]"
    @click="handleClick"
    @mouseenter="handleMouseEnter"
  >
    <span>{{ node.label }}</span>
    <i v-if="hasChildren" :class="bem.e('icon')"></i>
  </div>
</template>

<script lang="ts">
export default {
  name: 'cms-cascader-node',
  inheritAttrs: false
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { createNamespace } from '@chenms-zj/utils/create'
import { CascaderOption } from './cascaders'

const bem = createNamespace('cascader-node')

const props = defineProps({
  node: {
    type: Object as () => CascaderOption,
    required: true
  },
  level: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['expand', 'check'])

const isActive = computed(() => {
  // 实现激活状态逻辑
  return false
})

const isDisabled = computed(() => {
  return props.node.disabled === true
})

const hasChildren = computed(() => {
  return Array.isArray(props.node.children) && props.node.children.length > 0
})

function handleClick() {
  if (isDisabled.value) return

  if (hasChildren.value) {
    emit('expand', props.node, props.level)
  } else {
    emit('check', props.node, props.level)
  }
}

function handleMouseEnter() {
  // 处理鼠标悬停逻辑
}
</script>

<style scoped>
/* 组件样式可以在这里添加，或者在全局样式文件中定义 */
</style>
